module.exports = __webpack_public_path__ + "static/media/fasad7.103bf9d8.jpeg";